// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录入口
import login from '@/views/login';


// 用户登录
import userLogin from '@/views/login/userLogin';
// 用户注册
import userRegister from '@/views/login/userRegister';
// 专家登录
import agentLogin from '@/views/login/agentLogin';
// 管理登录
import adminLogin from '@/views/login/adminLogin';
// 首页
import webIndex from '@/views/index/index';
// 首页
import index from '@/views/index';


/**
 * 用户端
 */

// 专利检索-价值评估
import clientPatentSearch from '@/views/client/patentSearch'
// 评估记录
import clientEvalRecord from '@/views/client/evalRecord'
// 客户管理
import clientCustomerClient from '@/views/client/customerClient'
// 个人中心
import clientPersonCenter from '@/views/client/personCenter'
// 图表统计
import clientPlatformChart from '@/views/client/platformChart'


/**
 * 管理端
 */
// 账户管理
import sysAccount from '@/views/system/account';
// 案件管理
import sysCase from '@/views/system/case';
// 个人中心
import sysPersonCenter from '@/views/system/personCenter';
// 平台图表
import sysPlatformChart from '@/views/system/platformChart';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [
      {
        path: '/',
        name: '',
        component: webIndex,
        hidden: true,
        meta: {
            requireAuth: false
        }
      }, {
        path: '/login',
        name: 'login',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
      }, {
        path: '/index/index',
        name: 'webIndex',
        component: webIndex,
        hidden: true,
        meta: {
            requireAuth: false
        }
      },{
      path: '/userLogin',
      name: 'userLogin',
      component: userLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/userRegister',
      name: 'userRegister',
      component: userRegister,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/agentLogin',
      name: 'agentLogin',
      component: agentLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
      path: '/adminLogin',
      name: 'adminLogin',
      component: adminLogin,
      hidden: true,
      meta: {
          requireAuth: false
      }
    },{
        path: '/index',
        name: 'index',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
          {
            path: '/system/account',
            name: '帐户管理',
            component: sysAccount,
            meta: {
                requireAuth: true,
                roles: ['admin']
            }
          },{
            path: '/system/case',
            name: '案件管理',
            component: sysCase,
            meta: {
                requireAuth: true,
                roles: ['admin']
            }
          },{
            path: '/system/personCenter',
            name: '管理个人中心',
            component: sysPersonCenter,
            meta: {
                requireAuth: true,
                roles: ['admin']
            }
          },{
            path: '/system/platformChart',
            name: '平台图表',
            component: sysPlatformChart,
            meta: {
                requireAuth: true,
                roles: ['admin']
            }
          },{
            path: '/client/patentSearch',
            name: '专利检索',
            component: clientPatentSearch,
            meta: {
                requireAuth: true,
                roles: ['user']
            }
          },{
            path: '/client/evalRecord',
            name: '评估记录',
            component: clientEvalRecord,
            meta: {
                requireAuth: true,
                roles: ['user']
            }
          },{
            path: '/client/customerClient',
            name: '客户管理',
            component: clientCustomerClient,
            meta: {
                requireAuth: true,
                roles: ['user']
            }
          },{
            path: '/client/personCenter',
            name: '用户个人中心',
            component: clientPersonCenter,
            meta: {
                requireAuth: true,
                roles: ['user']
            }
          },{
            path: '/client/platformChart',
            name: '图表统计',
            component: clientPlatformChart,
            meta: {
                requireAuth: true,
                roles: ['user']
            }
          }
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js